module.exports = __webpack_public_path__ + "img/logo.c66acd6b.png";